<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gJx56p/tc-custom/9798886930405.jpg?1705540336480" alt="This image is the cover for the book Journey Across Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Journey Across Time
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-right:0mm;margin-left:0mm;font-size:16px;font-family:"Times New Roman","serif";margin:0mm;margin-bottom:.0001pt;'><em>Journey Across Time</em> opens a window to life in South Asia, which has changed vastly since Susan Gillerman Boggs began living there as a diplomat’s wife in 1985. In a captivating first-person narrative, Boggs takes the reader to remote places, many now closed to visitors. She describes experiences both exotic and hilarious, and adventures impossible to replicate. The author invites us to share the color and pageantry of festivals, religious rites, and parades of caparisoned elephants. She ventured into the Himalayas on perilous roads and was welcomed into a remote land of former headhunters. She dined with royalty and danced with a maharaja, conversed with Mother Teresa, met President Clinton, and appeared in a film starring Pierce Brosnan. She survived floods, political assassinations, and window-shattering bombs. She was bitten by a grouper in a coral lagoon, sneezed on by an elephant, and cornered in a cul-de-sac by angry bulls.<br/><br/></p><p style='margin-right:0mm;margin-left:0mm;font-size:16px;font-family:"Times New Roman","serif";margin:0mm;margin-bottom:.0001pt;'>Back on the home front, the author chronicles the daily joys and frustrations of diplomatic life with its cast of senior officials, mughals, intellectuals, and colorful characters.<br/><br/>With verve and self-deprecating humor, she describes the tribulations of managing a diplomatic household and orchestrating official events despite personal dramas, logistic challenges, and power outages. Join her in a truly remarkable <em>Journey Across Time</em>.</p><p style='margin-right:0mm;margin-left:0mm;font-size:16px;font-family:"Times New Roman","serif";margin:0mm;margin-bottom:.0001pt;'><br/></p><p><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Gillerman Boggs
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:8.0pt;margin-left:0mm;font-size:15px;font-family:"Calibri","sans-serif";text-align:justify;'><span style='font-size:16px;font-family:"Times New Roman","serif";'>Susan Gillerman Boggs, a native of St. Louis, Missouri, began traveling internationally at a young age. She earned a Master of Fine Arts in Musicology from Boston University and King&rsquo;s College, London, before working for opera companies across the United States in costume design and production. After her marriage to a U.S. diplomat in 1986, she spent 14 years living and traveling widely in South Asia. Susan now lives with her husband in Falls Church, Virginia. She has worked with the Washington National Opera, continues to sing with the Choral Arts Society of Washington, and is active in Falls Church Arts.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4445b928